// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__s88Q8","right":"styles_right__3BaL6"};